import {
  arrowLeft,
  backspaceIcon,
  banIcon,
  carIcon,
  checkCirclesIcon,
  chevronDoubleDownIcon,
  chevronDownIcon,
  chevronDownSquareIcon,
  chevronDownSquareSolidIcon,
  chevronUpIcon,
  chevronUpSquareIcon,
  chevronUpSquareSolidIcon,
  clockIcon,
  copyIcon,
  creditCardIcon,
  downloadIcon,
  editIcon,
  exclamationTriangleIcon,
  fileIcon,
  fileInvoiceDollarIcon,
  fileInvoiceIcon,
  filePlusIcon,
  fileSertificateIcon,
  filterActiveIcon,
  filterIcon,
  houseIcon,
  idBadgeIcon,
  idCardIcon,
  lineChartIcon,
  linkIcon,
  mobileIcon,
  moreHorizontalIcon,
  moreHorizontalOpenIcon,
  passportIcon,
  penIcon,
  refreshIcon,
  searchIcon,
  trashIcon,
  uploadCloudIcon,
  xIcon,
} from '@components-library/Icons/icons';
import { DEPRECATED_FA_GLOBAL_SPRITE } from '@components-library/Icons/interfaces';

export const iconList: Record<DEPRECATED_FA_GLOBAL_SPRITE, { path: string; width: number; height: number }> = {
  [DEPRECATED_FA_GLOBAL_SPRITE.creditCard]: creditCardIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.uploadCloud]: uploadCloudIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.x]: xIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.checkCircles]: checkCirclesIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.edit]: editIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.download]: downloadIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.trash]: trashIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.refresh]: refreshIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.moreHorizontal]: moreHorizontalIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.moreHorizontalOpen]: moreHorizontalOpenIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.link]: linkIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.chevronUp]: chevronUpIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.chevronDown]: chevronDownIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.filter]: filterIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.filterActive]: filterActiveIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.chevronDownSquare]: chevronDownSquareIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.chevronUpSquare]: chevronUpSquareIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.chevronUpSquareSolid]: chevronUpSquareSolidIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.chevronDownSquareSolid]: chevronDownSquareSolidIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.ban]: banIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.copy]: copyIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.search]: searchIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.backspace]: backspaceIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.idCard]: idCardIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.car]: carIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.passport]: passportIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.fileInvoiceDollar]: fileInvoiceDollarIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.file]: fileIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.idBadge]: idBadgeIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.house]: houseIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.filePlus]: filePlusIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.fileSertificate]: fileSertificateIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.pen]: penIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.chevronDoubleDown]: chevronDoubleDownIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.mobile]: mobileIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.fileInvoice]: fileInvoiceIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.exclamationTriangle]: exclamationTriangleIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.clock]: clockIcon,
  [DEPRECATED_FA_GLOBAL_SPRITE.arrowLeft]: arrowLeft,
  [DEPRECATED_FA_GLOBAL_SPRITE.lineChart]: lineChartIcon,
};
